import { render, staticRenderFns } from "./DateRangeDisplay.vue?vue&type=template&id=f0c79174&"
import script from "./DateRangeDisplay.vue?vue&type=script&lang=js&"
export * from "./DateRangeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports